import React from "react";
import { FaUsers, FaHandshake, FaRupeeSign, FaCloud } from 'react-icons/fa';
import { FaChartLine, FaHeadphones, FaMobileAlt, FaClone, FaTasks, FaHandsHelping, FaMale } from "react-icons/fa";

import "./Login.css";

class LoginLeftSidePage extends React.Component {
  render() {
    return (
      <div
        className="col-md-8 d-none d-sm-block company-window"
        style={{ backgroundImage: "url(/images/admin-1.jpg)" }}>
        <div className="company-window2">
          <div className="og-logo">
            <h2>Sell smarter and faster with the OGCRM.</h2>
            <div className="crm-features row">
              <div className="col-md-3">
                <h1>
                  <FaChartLine className="iconslogin" />
                </h1>
                <p>Increase lead conversion</p>
              </div>
              <div className="col-md-3">
                <h1>
                  <FaHandshake className="iconslogin" />
                </h1>
                <p>
                  Automate <br />
                  Follow Up
                </p>
              </div>
              <div className="col-md-3">
                <h1>
                  <FaRupeeSign className="iconslogin" />
                </h1>
                <p>Increase in Revenue</p>
              </div>
              <div className="col-md-3">
                <h1>
                  <FaUsers className="iconslogin" />
                </h1>
                <p>Retain your Old Customer</p>
              </div>
            </div>
            <div className="row crm-features">
              <div className="col-md-3">
                <h1>
                  <FaCloud className="iconslogin" />
                </h1>
                <p>Cloud CRM for Marketing Person</p>
              </div>
              <div className="col-md-3">
                <h1>
                  <FaHeadphones className="iconslogin" />
                </h1>
                <p>Record Calls with our Android App</p>
              </div>

              <div className="col-md-3">
                <h1>
                  <FaMobileAlt className="iconslogin" />
                </h1>
                <p>Mobile Dialler</p>
              </div>
              <div className="col-md-3">
                <h1>
                  <FaClone className="iconslogin" />
                </h1>
                <p>Offline Online CRM</p>
              </div>
            </div>

            <div className="col-md-12">
              <div className="text-center">
                <h2 className="">More Products</h2>
                <div className="row crm-features">
                  <div className="offset-md-2 col-md-3">
                    <h1>
                      <FaHandsHelping className="iconslogin" />
                    </h1>
                    <p>Helpdesk / Ticket CRM </p>
                  </div>
                  <div className="col-md-3">
                    <h1>
                      <FaMale className="iconslogin" />
                    </h1>
                    <p>HRMS </p>
                  </div>
                  <div className="col-md-3">
                    <h1>
                      <FaTasks className="iconslogin" />
                    </h1>
                    <p>Project Managment </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="text-center powered-by-section">
                <span className="powered-by">
                  Powered By&nbsp;
                  <a
                    target="_blank"
                    rel="noreferrer"
                    className=""
                    title="Powered By: OrgGen CRM"
                    href="http://www.orggen.com"
                  >
                    OrgGen Technologies
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default LoginLeftSidePage;
